// extracted by mini-css-extract-plugin
module.exports = {"bgDarken":"footer_bgDarken__1gJw1","footerLink":"footer_footerLink__16KLw","copy":"footer_copy__1RgF8"};